// registry/FieldRegistry.js
import TextField from "./typeimpl/TextField";
import NumberField from "./typeimpl/NumberField";
import BooleanField from "./typeimpl/BooleanField";
import DateTimeField from "./typeimpl/DateTimeField";
import EmailField from "./typeimpl/EmailField";
import PasswordField from "./typeimpl/PasswordField";
import UUIDField from "./typeimpl/UUIDField";
import FileUrlField from "./typeimpl/FileUrlField";
import ObjectField from "./typeimpl/ObjectField";
import EnumField from "./typeimpl/EnumField";
import CollectionObjectField from "./typeimpl/CollectionObjectField";
import MapField from "./typeimpl/MapField";
import SetField from "./typeimpl/SetField";
import ListComponent from "./ListComponent.jsx";

const registry = {
  // Text types
  STRING: TextField,
  CHAR_SEQUENCE: TextField,
  UUID: UUIDField,
  DATE: DateTimeField,
  TIME: DateTimeField,
  DATETIME: DateTimeField,
  FILE_URL: FileUrlField,
  EMAIL: EmailField,
  PASSWORD: PasswordField,
  
  // Number types
  INT: NumberField,
  DOUBLE: NumberField,
  FLOAT: NumberField,
  LONG: NumberField,
  SHORT: NumberField,
  NUMBER: NumberField,
  BYTE: NumberField,
  BIG_DECIMAL: NumberField,
  BIG_INT: NumberField,
  
  // Boolean types
  BOOLEAN: BooleanField,
  
  // Object types
  OBJECT: ObjectField,
  MAP: MapField,
  SET: SetField,
  
  // Select types
  ENUM: EnumField,
  COLLECTION_OBJECT: CollectionObjectField,
  
  // List type
  LIST: ListComponent,
  
  // Response data type
  RESPONSE_DATA_TYPE: ObjectField
};

export function getFieldComponent(type) {
  return registry[type] || (() => <div>Unsupported type: {type}</div>);
}
